<!-- onboarding-dashboard.component.html -->
<div class="container-fluid dashboard-wrapper py-4">
  
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
    <div>
      <h5 class="fw-bold mb-1">Employee Onboarding Dashboard</h5>
      <p class="text-muted mb-0">Overview of onboarding activities and workforce insights</p>
    </div>

    <button class="btn btn-primary px-4 mt-3 mt-md-0">
      + Add Employee
    </button>
  </div>

  <!-- Stats Cards -->
  <div class="row g-4 mb-4">

    <!-- <div class="col-xl-2 col-md-4 col-sm-6"> -->
    <div class="col">
      <div class="card stats-card active-card">
        <div class="card-body">
          <h6>Active Employees</h6>
          <h3>1,284</h3>
          <!-- <span>+12% this month</span> -->
        </div>
      </div>
    </div>

    <!-- <div class="col-xl-2 col-md-4 col-sm-6"> -->
    <div class="col">
      <div class="card stats-card left-card">
        <div class="card-body">
          <h6>Left Employees</h6>
          <h3>96</h3>
          <!-- <span>4 resignations this week</span> -->
        </div>
      </div>
    </div>

    <!-- <div class="col-xl-2 col-md-4 col-sm-6"> -->
    <div class="col">
      <div class="card stats-card pending-card">
        <div class="card-body">
          <h6>Pending</h6>
          <h3>48</h3>
          <!-- <span>Awaiting documents</span> -->
        </div>
      </div>
    </div>

    <!-- <div class="col-xl-3 col-md-6 col-sm-6"> -->
    <div class="col">
      <div class="card stats-card accepted-card">
        <div class="card-body">
          <h6>Accepted Offers</h6>
          <h3>212</h3>
          <!-- <span>Strong hiring pipeline</span> -->
        </div>
      </div>
    </div>

    <!-- <div class="col-xl-3 col-md-6"> -->
    <div class="col">
      <div class="card stats-card rejected-card">
        <div class="card-body">
          <h6>Rejected Offers</h6>
          <h3>34</h3>
          <!-- <span>16% rejection rate</span> -->
        </div>
      </div>
    </div>

  </div>

  <!-- Main Sections -->
  <div class="row g-4">

    <!-- Age Distribution -->
    <div class="col-lg-4">
      <div class="card dashboard-card h-100">
        <div class="card-header">
          <h5>Age Distribution</h5>
        </div>

        <div class="card-body">

          <div class="age-item">
            <div class="d-flex justify-content-between">
              <span>0-17 years</span>
              <strong>0%</strong>
            </div>
            <div class="progress">
              <div class="progress-bar bg-danger" style="width: 0%"></div>
            </div>
          </div>

          <div class="age-item">
            <div class="d-flex justify-content-between">
              <span>18-25 years</span>
              <strong>42%</strong>
            </div>
            <div class="progress">
              <div class="progress-bar bg-primary" style="width: 42%"></div>
            </div>
          </div>

          <div class="age-item">
            <div class="d-flex justify-content-between">
              <span>26-33 years</span>
              <strong>35%</strong>
            </div>
            <div class="progress">
              <div class="progress-bar bg-success" style="width: 35%"></div>
            </div>
          </div>

          <div class="age-item">
            <div class="d-flex justify-content-between">
              <span>34-41 years</span>
              <strong>15%</strong>
            </div>
            <div class="progress">
              <div class="progress-bar bg-warning" style="width: 15%"></div>
            </div>
          </div>

          <div class="age-item">
            <div class="d-flex justify-content-between">
              <span>42+ years</span>
              <strong>8%</strong>
            </div>
            <div class="progress">
              <div class="progress-bar bg-info" style="width: 8%"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Department Hiring -->
    <div class="col-lg-4">
      <div class="card dashboard-card h-100">
        <div class="card-header">
          <h5>Department Hiring</h5>
        </div>

        <div class="card-body">

          <div class="department-item">
            <div>
              <h6>Engineering</h6>
              <small>124 Employees</small>
            </div>
            <span class="badge bg-primary">+18</span>
          </div>

          <div class="department-item">
            <div>
              <h6>Human Resources</h6>
              <small>42 Employees</small>
            </div>
            <span class="badge bg-success">+6</span>
          </div>

          <div class="department-item">
            <div>
              <h6>Sales</h6>
              <small>88 Employees</small>
            </div>
            <span class="badge bg-warning text-dark">+12</span>
          </div>

          <div class="department-item">
            <div>
              <h6>Marketing</h6>
              <small>54 Employees</small>
            </div>
            <span class="badge bg-danger">+4</span>
          </div>

          <div class="department-item border-0 pb-0">
            <div>
              <h6>Operations</h6>
              <small>76 Employees</small>
            </div>
            <span class="badge bg-info text-dark">+9</span>
          </div>

        </div>
      </div>
    </div>

    <!-- Onboarding Progress -->
    <div class="col-lg-4">
      <div class="card dashboard-card h-100">
        <div class="card-header">
          <h5>Onboarding Progress</h5>
        </div>

        <div class="card-body">

          <div class="onboarding-step">
            <div class="d-flex justify-content-between">
              <span>Offer Letter Sent</span>
              <span>95%</span>
            </div>
            <div class="progress">
              <div class="progress-bar bg-primary" style="width:95%"></div>
            </div>
          </div>

          <div class="onboarding-step">
            <div class="d-flex justify-content-between">
              <span>Documents Submitted</span>
              <span>80%</span>
            </div>
            <div class="progress">
              <div class="progress-bar bg-success" style="width:80%"></div>
            </div>
          </div>

          <div class="onboarding-step">
            <div class="d-flex justify-content-between">
              <span>Background Verification</span>
              <span>68%</span>
            </div>
            <div class="progress">
              <div class="progress-bar bg-warning" style="width:68%"></div>
            </div>
          </div>

          <div class="onboarding-step">
            <div class="d-flex justify-content-between">
              <span>Orientation Completed</span>
              <span>52%</span>
            </div>
            <div class="progress">
              <div class="progress-bar bg-info" style="width:52%"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- Recent Activities -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card dashboard-card">
        <div class="card-header">
          <h5>Recent Onboarding Activities</h5>
        </div>

        <div class="card-body table-responsive">

          <table class="table align-middle">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Department</th>
                <th>Status</th>
                <th>Date</th>
                <th>Manager</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Rahul Sharma</td>
                <td>Engineering</td>
                <td><span class="badge bg-success">Completed</span></td>
                <td>12 May 2026</td>
                <td>Anita Verma</td>
              </tr>

              <tr>
                <td>Priya Mehta</td>
                <td>HR</td>
                <td><span class="badge bg-warning text-dark">Pending</span></td>
                <td>11 May 2026</td>
                <td>Karan Patel</td>
              </tr>

              <tr>
                <td>Arjun Nair</td>
                <td>Sales</td>
                <td><span class="badge bg-primary">In Progress</span></td>
                <td>10 May 2026</td>
                <td>Rohit Jain</td>
              </tr>

              <tr>
                <td>Sneha Kapoor</td>
                <td>Marketing</td>
                <td><span class="badge bg-danger">Rejected</span></td>
                <td>09 May 2026</td>
                <td>Simran Kaur</td>
              </tr>

            </tbody>

          </table>

        </div>
      </div>
    </div>
  </div>

</div>